/* RESPONSIBLE TEAM: team-omni */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default class SlackIntegrationSerializer extends EmbercomBaseSerializer {
  normalizeArrayResponse(
    store: any,
    primaryModelClass: any,
    payload: any,
    id: any,
    requestType: any,
  ) {
    if (!payload) {
      payload = { 'slack/integrations': [] };
    } else if (Array.isArray(payload)) {
      payload = { 'slack/integrations': payload };
    } else if (!payload['slack/integrations']) {
      if (payload.id) {
        payload = { 'slack/integrations': [payload] };
      } else {
        payload = { 'slack/integrations': [] };
      }
    }

    return super.normalizeArrayResponse(store, primaryModelClass, payload, id, requestType);
  }
}
